import { render, staticRenderFns } from "./CellRendererRoleActions.vue?vue&type=template&id=f0581ccc&"
import script from "./CellRendererRoleActions.vue?vue&type=script&lang=js&"
export * from "./CellRendererRoleActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports